<template>
  <div class="announcements" id="announcements">
    <div class="announcements-header">
      <div class="announcements-title">Анонсы</div>
<!--      <div class="announcements-nav">-->
<!--        <div-->
<!--            @click="mySwiper.slidePrev()"-->
<!--            :class="['announcements-swiper-prev',activeIndex !== 0 ? '' : 'disabled']"-->
<!--        >-->
<!--          <svg width="104" height="76" viewBox="0 0 104 76" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <path d="M103.004 38L3.0039 38" stroke="#BA8748" stroke-width="3"/>-->
<!--            <path d="M39 2.00024L3 38.0002L39 74.0002" stroke="#BA8748" stroke-width="3"/>-->
<!--          </svg>-->
<!--        </div>-->
<!--        <div-->
<!--            @click="mySwiper.slideNext()"-->
<!--            :class="['announcements-swiper-next',activeIndex !== content.slides.length/2-1 ? '' : 'disabled']"-->
<!--        >-->
<!--          <svg width="103" height="76" viewBox="0 0 103 76" fill="none" xmlns="http://www.w3.org/2000/svg">-->
<!--            <path d="M0.00390625 38L100.004 38" stroke="#BA8748" stroke-width="3"/>-->
<!--            <path d="M64.0078 2.00024L100.008 38.0002L64.0078 74.0002" stroke="#BA8748" stroke-width="3"/>-->
<!--          </svg>-->
<!--        </div>-->
<!--      </div>-->
    </div>
    <div v-swiper:mySwiper="swiperOption" @slideChange="myChanger" class="announcements-swiper">
      <div class="swiper-wrapper">
        <div class="swiper-slide announcements-slide" :key="index" v-for="(item,index) in content.slides">
          <div class="announcements-overlay">
            <div class="announcements__wrapper">
              <img :src="item.image">
            </div>
            <div class="announcements-content-wrapper">
              <p class="announcements-overlay-title">
                <span v-html="item.title" />
              </p>
              <div class="announcements-content">
                <span class="announcements-content-date">{{ item.date }}</span>
                <p class="announcements-content-text" v-html="item.text" />
                <button class="announcements-content-btn">Узнать больше</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: "Announcements",
  props: ['content'],
  components: {},
  data() {
    return {
      activeIndex: 0,
      swiperOption: {
        init: true,
        slidesPerView:1,
        spaceBetween: 80,
        breakpoints: {
          450: {
            slidesPerColumn: 2,
            slidesPerColumnFill: 'row',
          }
        }
      },
    }
  },
  methods: {
    myChanger() {
      console.log(this.activeIndex)
      this.activeIndex = this.mySwiper.realIndex
    },
  }
}
</script>

<style lang="scss">
@import 'announcements';
</style>
